import auth from "./auth";
import api from "./api";

const MERCHANT_BASE_SERVICE_URL = "merchant-service";
const MERCHANT_AUTH_BASE_SERVICE_URL = "merchant-auth-service"

export default {
    checkSubdomain(param) {
        return new Promise((resolve, reject) => {
            api.post(
                MERCHANT_BASE_SERVICE_URL + "/cms/subdomain/exist",
                param.payload,
                auth.getHeader()
            )
            .then(response => {
                return resolve(response);
            })
            .catch((status, error) => {
                reject(status, error);
            });
        });
    },
    updateMerchant(param) {
        return new Promise((resolve, reject) => {
            api.post(
                MERCHANT_BASE_SERVICE_URL + "/cms/setup/update/merchant",
                param.payload,
                auth.getHeader()
            )
            .then(response => {
                return resolve(response);
            })
            .catch((status, error) => {
                reject(status, error);
            });
        });
    },
    updateSubscribe(param) {
        return new Promise((resolve, reject) => {
            api.post(
                MERCHANT_AUTH_BASE_SERVICE_URL + "/user/update_subscribe/" + param.uuid,
                param.payload,
                auth.getHeader()
            )
            .then(response => {
                return resolve(response);
            })
            .catch((status, error) => {
                reject(status, error);
            });
        });
    },
    updateStep(param) {
        return new Promise((resolve, reject) => {
            api.post(
                MERCHANT_BASE_SERVICE_URL + "/cms/setup/update/step",
                param.payload,
                auth.getHeader()
            )
            .then(response => {
                return resolve(response);
            })
            .catch((status, error) => {
                reject(status, error);
            });
        });
    }
};
